import { render, staticRenderFns } from "./project-item.vue?vue&type=template&id=a3016740&"
import script from "./project-item.vue?vue&type=script&lang=js&"
export * from "./project-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports